// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#declarationCheckbox,
#consentCheckbox,
#pregnancy {
  border: 2px solid #25335b;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Proposalsummary.css"],"names":[],"mappings":"AAAA;;;EAGE,yBAAyB;AAC3B","sourcesContent":["#declarationCheckbox,\r\n#consentCheckbox,\r\n#pregnancy {\r\n  border: 2px solid #25335b;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
